import { RootState } from '../../store';
import { createSelector } from 'reselect';

const selectGraphBarDescriptionVisibilityReducer = (state: RootState) => state.graphBarDescriptionVisibility;

export const selectGraphBarDescriptionVisibility = createSelector(
    selectGraphBarDescriptionVisibilityReducer,
    (graphBarDescriptionVisibility) => graphBarDescriptionVisibility.visible,
);
